/**
 * Where a Sabine chat about each kind of record is filed, keyed by the record
 * kind: a shared thread's contextType, and the `recordKind` a coach page sends
 * with each turn.
 *
 * - `session` is the SabineChatSession source its saved thread lives under.
 *   The share seeds a copy from that saved thread (lib/ai-chat-subject.js) and
 *   the chat library files the copy beside it (lib/chat-library/service.js);
 *   both read this one table, so they cannot disagree on where a thread lives.
 *   A readout's thread stays under RESULT_COACH, where saved ones already are.
 * - `feedback` is the AIChatFeedback source each turn is logged under, one per
 *   surface, so a quality report on one surface reads only its own turns.
 */
const SOURCES_BY_RECORD_KIND = {
  SIMULATION_RESULT: { session: "RESULT_COACH", feedback: "RESULT_COACH" },
  COG_REPORT: { session: "RESULT_COACH", feedback: "DEAL_CLINIC" },
  TRANSCRIPT_RESULT: { session: "TRANSCRIPT_COACH", feedback: "TRANSCRIPT_COACH" },
  PLAYBOOK: { session: "PLAYBOOK", feedback: "PLAYBOOK" },
  REPORTS_CHAT: { session: "REPORTS", feedback: "REPORTS" },
};

// The scenario type a coach page sent before it sent `recordKind`.
const RECORD_KIND_ALIASES = {
  DEAL_DIAGNOSIS: "COG_REPORT",
  TRANSCRIPT: "TRANSCRIPT_RESULT",
};

/** @returns {{ session: string, feedback: string }|null} null for any other kind */
export function getSabineSources(kind) {
  const value = String(kind || "").toUpperCase();
  return SOURCES_BY_RECORD_KIND[RECORD_KIND_ALIASES[value] || value] || null;
}

/** @returns {string|null} null for a kind no chat is saved under */
export function getSabineSessionSource(kind) {
  return getSabineSources(kind)?.session || null;
}
